import { View } from 'foundations-components/components/View';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { List } from 'foundations-components/transitional/components/List';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer'; // Keep the import

import * as React from 'react';
import styled from 'styled-components';
import { LISTBOX_ID } from '../constants';
import { getOptionId } from './SearchBar';
import { SearchOption } from './SearchOption';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledListItem = styled.li.withConfig({
  displayName: "SearchDropdown__StyledListItem",
  componentId: "sc-1ljbnmv-0"
})(({
  theme: _theme,
  isActive
}) => {
  const theme = _theme;
  return {
    padding: theme.space['250'],
    backgroundColor: isActive ? theme.color['temp-do-not-use-fill-field-hover'] : undefined,
    '&:hover': {
      backgroundColor: theme.color['temp-do-not-use-fill-field-hover']
    },
    cursor: 'pointer'
  };
});
export function SearchDropdown({
  activeIndex,
  error,
  loading,
  onResultSelect,
  options,
  searchTerm,
  setActiveIndex
}) {
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-default",
    borderRadius: "200",
    boxShadow: "400",
    insetInlineEnd: '0',
    insetInlineStart: '0',
    marginBlockStart: "100",
    maxBlockSize: "300px",
    position: "absolute",
    zIndex: "300",
    children: /*#__PURE__*/_jsxs(ScrollContainer, {
      maxBlockSize: "300px",
      minBlockSize: "50px",
      maxHeight: 300,
      children: [loading && /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        justifyContent: "center",
        blockSize: "100%",
        paddingBlockStart: "100",
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          grow: true
        })
      }), error && /*#__PURE__*/_jsx(ErrorMessage, {
        type: "badRequest"
      }), !loading && !error && /*#__PURE__*/_jsx(List, {
        "data-test-id": "search-results-list",
        role: "listbox",
        id: LISTBOX_ID,
        children: options.map((item, index) => /*#__PURE__*/_jsx(StyledListItem, {
          "aria-selected": activeIndex === index,
          id: getOptionId(index),
          isActive: activeIndex === index,
          onMouseEnter: () => setActiveIndex(index),
          onClick: () => onResultSelect(item),
          role: "option",
          tabIndex: -1,
          children: /*#__PURE__*/_jsx(SearchOption, {
            item: item,
            searchTerm: searchTerm
          })
        }, `option-${index}`))
      })]
    })
  });
}